//Framework, Stores, and Services
import Framework from 'framework';
import Cookies from 'cookies-js';
import moment from 'moment';
import actService from 'framework/services/actService';
import ProfileStore from 'framework/stores/ProfileStore';
import ProspectProfileStore from 'framework/stores/ProspectProfileStore';
import AlertNotificationStore from 'framework/stores/AlertNotificationStore';
import ClubsStore from 'framework/stores/ClubsStore';
import ClubStore from 'framework/stores/ClubStore';
import nearestClubStore from 'framework/stores/nearestClubStore';
import UrlStore from 'framework/stores/UrlStore';
import constants from 'lib/constants';
import placeholder from 'lib/placeholder-polyfill';
import urlUtils from 'lib/url-utils';
import eventTracker from 'components/sdi-tracking';
import SessionStorage from 'lib/session-storage';
import authUtils from 'lib/auth-utils';
import memberProcessService from 'framework/services/memberProcessService';

// Import sub-optimal browser detection
import detectSubOptimal from 'lib/sub-optimal-detection';

const dateFormat = 'DD-MM-YYYYhh:mm:ss';

function initProfileStore() {
	if(
		Framework.global.lt.pageProperties.limitedProfile ||
		(Framework.global.lt.api.apimUrl && Framework.global.lt.api.apimKey)
	) {
		ProfileStore.initialize();
	}
}

function addOmsDataToLinks(paramString) {
	$('a[data-omslink="true"]').each(function() {
		let href = $(this).attr('href');

		if(href) {
			href += paramString;
			$(this).attr('href', href);
		}
	});
}

function buildOmsParams(referral, promotionName, utm) {
	let params = '';

	if(referral) {
		const referralInfo = referral.split('|');
		let code = encodeURIComponent(referralInfo[0]);
		params += '&referral=' + code + '&source=' + referralInfo[1];
	}

	if(promotionName) {
		params += '&promotionName=' + promotionName + '&source=web';
	}

	if(utm) {
		_.each(utm, (value, param)=> {
			params += '&' + param + '=' + value;
		});
	}

	addOmsDataToLinks(params);
}

function checkOmsData() {
	// check for referral cookie information and apply it to oms links
	const storedReferralInfo = Cookies.get(constants.memberReferralCookieName);
	// get corporate membership cookie
	let promotionName = '';
	const storedPromotionInfo = Cookies.get(constants.cookieCorpMembership);
	if(storedPromotionInfo !== null && typeof storedPromotionInfo !== 'undefined' && storedPromotionInfo.length > 0) {
		promotionName = storedPromotionInfo.split('|')[0];
	}
	// check utm data
	const utmData = SessionStorage.get('utm_params');

	buildOmsParams(storedReferralInfo, promotionName, utmData);
}

function checkRoles(obj) {
	// check if cookie predates date new service and thus does not contain date object
	if(obj.length && obj.length < 2) {
		// if so, we'll check the roles regardless
		return true;
	} else if(obj.length && obj.length === 2) {
		// check that the date the cookie was set
		const dateCheck = moment(obj[1], dateFormat).isBefore(moment().subtract(24, 'hours'));
		if(dateCheck) {
			// if the last time the cookie was set is greater than 24 hours, we'll get a new one
			return true;
		} else{
			return false;
		}
	} else{
		return false;
	}
}

function parseJwt(token) {
	var base64Url = token.split('.')[1];
	var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
	var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
		return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
	}).join(''));
	return JSON.parse(jsonPayload);
}

function checkAuthorized(token, authRoleClasses, isNewJwt) {
	let jwtObj = parseJwt(token);
	if(isNewJwt) {
		if(jwtObj && jwtObj.roles) {
			let bodyClassesArray = authRoleClasses[0].split(',');
			let jwtClasses = jwtObj.ltAuth.split(' ');
			//Using for since I saw multiple posts about it being faster than foreach for small arrays
			for(let i = 0, len = jwtClasses.length; i < len; i++) {
				if(bodyClassesArray.indexOf('ar-' + jwtClasses[i]) > -1) {
					return true;
				}
			}
		}

	} else{
		if(jwtObj && jwtObj.ltAuth) {
			let bodyClassesArray = authRoleClasses[0].split(' ');
			let jwtClasses = jwtObj.ltAuth.split(' ');
			//Using for since I saw multiple posts about it being faster than foreach for small arrays
			for(let i = 0, len = jwtClasses.length; i < len; i++) {
				if(bodyClassesArray.indexOf('ar-' + jwtClasses[i]) > -1) {
					return true;
				}
			}
		}
	}
	return false;
}

function handleAuthorization(profile) {
	return new Promise((resolve) => {
		// find any role classes on this page
		const authRoleClasses = document.getElementsByTagName('body')[0].className.match(/ar-.*/);
		if(!authRoleClasses) {
			// no roles authored, let the user in
			resolve(true);
		} else{
			// grab authorization cookie with jwt containing roles information
			const ltAuthCookie = Cookies.get(constants.cookieLtAuthorization) || null;
			const ltAuthV2Cookie = Cookies.get(constants.cookieLtAuthorizationV2) || null;
			let isNewJwt = false;
			if(ltAuthV2Cookie) {
				isNewJwt = true;
				Cookies.expire(constants.cookieLtAuthorization);
				resolve(checkAuthorized(ltAuthV2Cookie, authRoleClasses, isNewJwt));
			} else if(ltAuthCookie) {
				let getNewRoles = false;
				// split the cookie into jwt and cookie set date
				const ltAuthObj = ltAuthCookie.split('|');
				// set jwt to first object in array
				let jwt = ltAuthObj[0];
				// check if we need to get new roles from service
				getNewRoles = checkRoles(ltAuthObj);
				// if the roles haven't been checked recently, get a new jwt token using profile token
				if(getNewRoles) {
					return actService.api.getJwt(profile.token).then((data) => {
						// set new jwt
						jwt = data.jwt;
						// set cookie with new jwt information
						Cookies.set(constants.cookieLtAuthorization, jwt + '|' + moment().format(dateFormat).toString(), { expires: moment().add(75, 'days').toDate() });
						// parse jwt and determine authorized status
						if(jwt) {
							resolve(checkAuthorized(jwt, authRoleClasses, isNewJwt));
						}
					}, (error) => {
						Cookies.expire(constants.cookieLtAuthorization);
						resolve(checkAuthorized(jwt, authRoleClasses, isNewJwt));
					});
				} else{
					resolve(checkAuthorized(jwt, authRoleClasses, isNewJwt));
				}
			} else{
				//When we don't have an authorization key cookie, invalidate the session and redirect to the login page to avoid
				//the scenario where remembered users are sent to the "unauthorized" page even if they should have access to it
				authUtils.invalidateSessions();
				resolve(false);
			}
		}
	});
}

export default {
	run() {

		// Wire in actions to support callers who use window.LtFramework.action.someActionName() for non-reflux actions
		// Or Framework.actions.someActionName() in this repo
		Framework.actions.updateClub = ClubStore.updateClub;
		Framework.actions.urlUpdated = UrlStore.urlUpdated;
		Framework.actions.updateUrl = UrlStore.updateUrl;
		Framework.actions.bindPartnerUrls = UrlStore.bindPartnerUrls;
		Framework.actions.updateProspectClub = ProspectProfileStore.updateProspectClub;
		Framework.actions.searchForNearestClub = nearestClubStore.searchForNearestClub;
		Framework.actions.createSuccessNotification = AlertNotificationStore.createSuccessNotification;
		Framework.actions.createInfoNotification = AlertNotificationStore.createInfoNotification;
		Framework.actions.createWarningNotification = AlertNotificationStore.createWarningNotification;
		Framework.actions.createDangerNotification = AlertNotificationStore.createDangerNotification;
		Framework.actions.closeNotification = AlertNotificationStore.closeNotification;

		if(window != null) {
			Framework.mountTo(window);
		}

		// initialize polyfills
		placeholder.polyfill();
		detectSubOptimal.detect();
		eventTracker.trackEvents();

		// determine if member site
		var isMemberSite = (Framework.global.lt.pageProperties.experienceType === constants.experienceTypeMember || Framework.global.lt.pageProperties.experienceType === constants.experienceTypeToken || $('#clubLocator').length > 0);
		var isApp = Framework.global.lt.pageProperties.selectors.indexOf('app') >= 0;
		// check for UTM parameters and store them
		if(urlUtils.checkForParams('utm')){
			urlUtils.storeParams('utm', 'utm_params');
		}
		var $omsLinks = $('a[data-omslink="true"]');
		if(isMemberSite){
			// listen for changes to club
			// update recent clubs when the current club has been determined
			// and then unsubscribe
			let unsubFromClubStore = ClubStore.listen((clubData) => {
				// Flow: 3
				window.ef.recentClubStore.addRecentClub(clubData);
				// should only add a recent club once

				unsubFromClubStore();
			});

			// listen for profileStore update and then check for
			let unsubFromProfileStore = ProfileStore.listen((profile) => {
				if(!isApp) {
					// once the profileStore is set, check for stored reactivation alerts that need to be surfaced
					checkReactivationAlerts(profile);
				}
				let jsForcedAuth = (window.pageConfig && window.pageConfig.auth && window.pageConfig.auth.forceJavascriptAuth ) ? window.pageConfig.auth.forceJavascriptAuth : false;
				let jsForcedRememberedAuth = (window.pageConfig && window.pageConfig.auth && window.pageConfig.auth.forceRememberedAuth) ? window.pageConfig.auth.forceRememberedAuth : false;
				if(jsForcedAuth && !(window.location.href.indexOf('author') > -1)) {
					let redirectToLoginPage = false;
					if(jsForcedRememberedAuth) {
						// only authenticated users can access this page, others redirected to login page
						redirectToLoginPage = Boolean(profile.memberState !== constants.memberState.authenticated);
					} else{
						// only authenticated or remembered users can access this page, others redirected to login page
						redirectToLoginPage = Boolean(profile.memberState !== constants.memberState.authenticated && profile.memberState !== constants.memberState.remembered);
					}
					// don't redirect urls that came in with a valid Customer Token query parameter (AEMPLAT-542)
					let isAlreadyAuthenticated = Boolean(profile.authToken);
					if(!isAlreadyAuthenticated && redirectToLoginPage) {

						const loginResource = urlUtils.removeCtIfPresent(Framework.global.lt.globalPageDrivers.global.loginResource);

						window.location.href = loginResource; 
					} else{
						handleAuthorization(profile).then((authorization) => {
							const authorized = authorization;
							//Check if we haven't already set a redirect to the login page and if we are not authorized to send the user to the unauthorized page
							let unauthTarget = (typeof window.pageConfig.auth.unauthorizedPath !== 'undefined') ? window.pageConfig.auth.unauthorizedPath : null;
							if(isApp){
								//Check if we have the mobile unauthorized page
								unauthTarget = (window.pageConfig.auth.unauthorizedPathMobile && typeof window.pageConfig.auth.unauthorizedPathMobile !== 'undefined' && window.pageConfig.auth.unauthorizedPathMobile !== 'undefined') ? window.pageConfig.auth.unauthorizedPathMobile : unauthTarget;
								//Once have the target check if .app already exists
								unauthTarget = (unauthTarget && typeof unauthTarget !== 'undefined' && unauthTarget !== 'undefined' && !unauthTarget.includes('.app.')) ? unauthTarget.replace('.html', '.app.html') : unauthTarget;
							}
							if(!authorized && (unauthTarget && typeof unauthTarget !== 'undefined' && unauthTarget !== 'undefined')) {
								window.location.href = unauthTarget;
							}
						});
					}
				}
				unsubFromProfileStore();
			});
			// Flow: 1
			// initialize Clubs and Profile
			ClubStore.initialize();
			initProfileStore();
			ClubsStore.initialize();
		} else if(Framework.global.lt.pageProperties.experienceType === constants.experienceTypeProspect) {
			// initialize Club only
			ClubStore.initializeClub();
			ClubsStore.initialize();
			// check for oms urls on the page
			if($omsLinks.length > 0) {
				// check for stored referral information to add to oms links
				checkOmsData();
			}
			// If needed, wait for the Prospect Profile Store to Initialize then Initialize the Club Store
			// In the case where the store has been already initialized then we'll call the update Club action
			// this should only affect National Pages on Prospect
			if(!Framework.global.lt.pageProperties.disableProspectGeoLocation) {
				ProspectProfileStore.listen((profile) => {
					if(!ClubStore.initialized()){
						ClubStore.initializeClub(profile.club);
					}else{
						ClubStore.updateClub(profile.club);
					}
				});
				window.ef.prospectProfileStore.initialize();
			}

		} else if(Framework.global.lt.pageProperties.experienceType === constants.experienceTypeWork) {
			// listen for changes to club
			// update recent clubs when the current club has been determined
			// and then unsubscribe
			let unsubFromClubStore = ClubStore.listen((clubData) => {
				// Flow: 3
				window.ef.recentClubStore.addRecentClub(clubData);
				// should only add a recent club once

				unsubFromClubStore();
			});

			initProfileStore();
			ClubStore.initializeClub();
		} else if(Framework.global.lt.pageProperties.experienceType === constants.experienceTypeSport) {
			// listen for changes to club
			// update recent clubs when the current club has been determined
			// and then unsubscribe
			let unsubFromClubStore = ClubStore.listen((clubData) => {
				// Flow: 3
				window.ef.recentClubStore.addRecentClub(clubData);
				// should only add a recent club once

				unsubFromClubStore();
			});

			initProfileStore();
			ClubStore.initializeClub();
			ClubsStore.initialize();
		} else if(Framework.global.lt.pageProperties.experienceType === constants.experienceTypeWorkProspect || Framework.global.lt.pageProperties.experienceType === constants.experienceTypeLthealth) {
			initProfileStore();
		} else if(Framework.global.lt.pageProperties.experienceType === constants.experienceTypeSwim){
			// noop
		}
		UrlStore.initialize();
		var formSuccess = SessionStorage.get('form-succeeded');
		if(formSuccess ){
			SessionStorage.remove('form-succeeded');
			Framework.actions.collectAnalytics(formSuccess);
		}
	}

};

// TODO: Move to aem-components/src/main.ts?
function checkReactivationAlerts(profile) {
	// check if ProfileStore has set necessary eligibilities in storage
	var storedStudentReactivationAlert = SessionStorage.get(constants.studentReactivationAlertEligible);
	var storedOnHoldReactivationAlert = SessionStorage.get(constants.onHoldReactivationAlertEligible);
	// check if user has dismissed reactivation alerts
	var dismissedStudentNotification = SessionStorage.get(constants.dismissedStudentReactivateNotification);
	var dismissedOnHoldNotification = SessionStorage.get(constants.dismissedOnHoldReactivateNotification);
	// if eligible from profile and user has not previously dismissed notification check if student reactivation dates are valid
	if(storedStudentReactivationAlert && !dismissedStudentNotification) {
		memberProcessService.api.validateReactivationDate().then((response) => {
			if(response.config.activationAvailable) {
				// create and fire off alert notification
				var studentReactivationMessage = `Your membership is on Student Flex. <a href="${LtFramework.global.lt.globalPageDrivers.account.reactivateMembership}">Activate Membership.</a>`;

				Framework.actions.createWarningNotification(studentReactivationMessage, false, true, 'studentFlexReactivation');
			}
		});
	}
	// display on hold reactivation notification
	if(storedOnHoldReactivationAlert && !dismissedOnHoldNotification) {
		var dateString = '';
		if(storedOnHoldReactivationAlert.date) {
			dateString = ' until ' + storedOnHoldReactivationAlert.date;
		}

 		var onHoldReactivationMessage = `Digital membership is active. Club Access membership is on-hold${dateString}.`;
		var onHoldReactivationMessageAndLink =
			`${onHoldReactivationMessage} <a href="${LtFramework.global.lt.globalPageDrivers.account.reactivateMembership}">Activate Club Access.</a>`;

		// We're going to show a message indicating club access is on hold
		const isPrimaryMember = profile.memberDetails.memberType === 'Primary';
		const isPartnerMember = profile.memberDetails.memberType === 'Partner';

		if (profile.initialized && profile.memberDetails) {
			if (isPrimaryMember || isPartnerMember) {
				showReactivationWarning(onHoldReactivationMessageAndLink);
			} else {
				// Secondary and Junior memberTypes are not authorized to reactivate their membership, so don't show the link
				showReactivationWarning(onHoldReactivationMessage);
			}
		}
	}
}

function showReactivationWarning(message) {
	Framework.actions.createWarningNotification(message, false, true, 'onHoldReactivation');
}
